export const getSubPaths = (blacklistPaths, key) =>
  blacklistPaths
    .filter(path => path.startsWith(`${key}.`))
    .map(path => path.substr(key.length + 1));
